'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reselect = require('reselect');

exports.default = function (expectedPopupId) {
    return (0, _reselect.createSelector)(function (state) {
        return state.getIn(['app', 'popup', 'active']);
    }, function (activePopup) {
        return activePopup.has(expectedPopupId);
    });
}; // Lib


//////////////////
// WEBPACK FOOTER
// ./src/client/components/popupPanel/popupOpenSelector.js
// module id = 141
// module chunks = 0